import { render, staticRenderFns } from "./RoomInfo.vue?vue&type=template&id=d28180c4&scoped=true"
import script from "./RoomInfo.vue?vue&type=script&lang=js"
export * from "./RoomInfo.vue?vue&type=script&lang=js"
import style0 from "./RoomInfo.vue?vue&type=style&index=0&id=d28180c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28180c4",
  null
  
)

export default component.exports